<template>
  <app-modal
    :model-value="true"
    size="sm"
    data-locator="ai-assistant-upgrade-dialog"
    @cancel="$emit('close')"
  >
    <template #title>
      {{ $t(`${TRANSLATION_KEY_PREFIX}.title`) }}
    </template>

    <template #body>
      <!-- Illustration -->
      <img
        :src="previewSvg"
        alt="Upgrade Preview"
        class="upgrade-dialog__preview-img mb-6"
      />

      <p class="upgrade-dialog__subtitle text--small mb-0">
        <strong>{{ $t(`${TRANSLATION_KEY_PREFIX}.subtitleHighlight`, { limit: conversationLimit, n: conversationLimit ?? 0 }) }}</strong>
      </p>
      <p class="upgrade-dialog__subtitle text--small mb-5">
        {{ $t(`${TRANSLATION_KEY_PREFIX}.subtitleText`) }}
      </p>

      <ul class="upgrade-dialog__benefits pa-0">
        <li
          v-for="(benefit, index) in BENEFITS_KEYS"
          :key="index"
          class="d-flex align-center column-gap-2 mb-2"
        >
          <app-material-icon name="check" color="#7247C9" :size="20" />
          <span class="text--small">{{ $t(`${TRANSLATION_KEY_PREFIX}.benefits.${benefit}`) }}</span>
        </li>
      </ul>
    </template>

    <template #footer>
      <app-button
        :href="CALENDLY_URL"
        type="primary"
        target="_blank"
        rel="noopener noreferrer"
        data-locator="upgrade-dialog-cta-button"
        @click="$emit('close')"
      >
        {{ $t(`${TRANSLATION_KEY_PREFIX}.ctaButton`) }}
        <template #right-icon>
          <app-material-icon name="open_in_new" color="inherit" :size="16" />
        </template>
      </app-button>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import i18n, { type AvailableLocale } from '@/plugins/i18n'

const DEFAULT_LOCALE: AvailableLocale = 'fr'

const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantUpgradeDialog'
const CALENDLY_URL = 'https://calendly.com/sowvarnie-jeyakumar-closd/presentation-closd'
const BENEFITS_KEYS = ['unlimited', 'time', 'sourced']

export default defineComponent({
  name: 'AIAssistantUpgradeDialog',
  emits: ['close'],
  props: {
    conversationLimit: {
      type: Number as () => number | null,
      default: null,
    },
  },
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
      BENEFITS_KEYS,
      CALENDLY_URL,
    }
  },
  computed: {
    previewSvg(): string {
      const safeLocale = (i18n.global.availableLocales as string[]).includes(this.$i18n.locale)
        ? this.$i18n.locale as AvailableLocale
        : DEFAULT_LOCALE
      return new URL(`../../assets/img/ai-assistant/protege-upgrade-preview-${safeLocale}.svg`, import.meta.url).href
    },
  },
})
</script>

<style scoped lang="scss">
.upgrade-dialog {
  &__subtitle {
    color: #103051;
    line-height: 20px;
  }

  &__benefits {
    color: #103051;
  }

  &__preview-img {
    width: 100%;
    height: auto;
    display: block;
  }
}
</style>
